import { gql, useQuery } from '@apollo/client';

export const SIGN_IN = gql`
  mutation sign_in($data: SignInInputType!) {
    response: sign_in(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const SIGN_UP = gql`
  mutation sign_up($data: SignUpInputType!) {
    response: sign_up(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const RECOVER_PASSWORD = gql`
  mutation recover_password($data: RecoverPasswordInputType!) {
    response: recover_password(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation reset_password($data: ResetPasswordInputType!) {
    response: reset_password(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const RESEND_VERIFICATION_EMAIL = gql`
  mutation resend_verification_email($data: ResendVerificationEmailInputType!) {
    response: resend_verification_email(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const VERIFY_MAGIC_LINK = gql`
  query verify_magic_link($data: VerifyMagicLinkInputType) {
    response: verify_magic_link(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation refresh_token($data: RefreshTokenInputType) {
    refresh_token(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const LOGOUT = gql`
  mutation logout($data: LogoutInputType) {
    logout(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_OWNER = gql`
  query get_owner {
    response: get_owner {
      hasError
      data
      message
    }
  }
`;

export const VERIFY_EMAIL = gql`
  query verify_email($data: VerifyEmailInputType!) {
    response: verify_email(data: $data) {
      hasError
      message
      data
    }
  }
`;

export function useGetOwner() {
  return useQuery(GET_OWNER);
}
